module.exports = __webpack_public_path__ + "55745c73eb36b664072c81f4b4976fe7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/sm.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/sm.svg
// module chunks = 0